import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Valentina M.',
    info: '28 años, Buenos Aires',
    quote: 'Me sentía perdida y esta guía me dio calma desde el primer día'
  }, {
    name: 'Camila R.',
    info: '31 años, Córdoba',
    quote: 'Por fin entendí a mi bebé sin sentirme insegura todo el tiempo'
  }, {
    name: 'Lucía G.',
    info: '26 años, Rosario',
    quote: 'Es simple, clara y te hace sentir acompañada'
  }];
  return <section className="w-full bg-sand-100 py-24 md:py-32 px-6" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-141">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-10 flex flex-col items-center text-center" data-id="element-142">
              <div className="flex gap-1 mb-8" data-id="element-143">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-warm-500 text-warm-500" data-id="element-144" />)}
              </div>

              <p className="font-serif italic text-xl text-charcoal-500 mb-10 flex-grow leading-relaxed" data-id="element-145">
                "{testimonial.quote}"
              </p>

              <div data-id="element-146">
                <p className="text-charcoal-700 font-medium text-sm tracking-wider uppercase mb-1" data-id="element-147">
                  {testimonial.name}
                </p>
                <p className="text-charcoal-300 text-sm font-light" data-id="element-148">
                  {testimonial.info}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}